<template>
  <div>
    <div class="element-wrapper compact">
      <div class="element-actions">
        <form class="form-inline justify-content-sm-end">
          <label class="smaller" for="">Order By</label>
          <select class="form-control form-control-sm form-control-faded" v-model="selectedAccountingPeriod">
            <option v-for="option in accountingPeriods" v-bind:value="option.value">
              {{ t.filter.accounting[option.value] }}
            </option>
          </select>
        </form>
      </div>
      <h6 class="element-header">
        {{ t.navigation.financial_overview }}
      </h6>
      <div class="element-box-tp" v-intro="tinfo.OVERVIEW_FINANCIAL" v-intro-position="'top'">
        <div class="row">
          <div class="col-sm-12 col-lg-12 col-xxl-6">
            <div class="element-balances justify-content-between mobile-full-width pb-2 pt-2 b-b">
              <div class="balance balance-v2">
                <div class="balance-title">
                  {{ t.navigation.total_amount_of_wager }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.total_amount_of_wager"></i>
                </div>
                <div class="balance-value" v-tooltip="getAmountMoney('general', 1)">
                  <span class="d-xxl-none">{{ getAmountMoney ('general') }}</span>
                  <span class="d-none d-xxl-inline-block">{{ getAmountMoney ('general') }}</span>

                  <span v-if="getPercentageChangeAmount('general') != 0" class="trending" :class="(getPercentageChangeAmount('general') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
                            <span>{{ getPercentageChangeAmount('general') }}%</span>
                              <i class="os-icon" :class="(getPercentageChangeAmount('general') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
                  </span>
                </div>
              </div>
              <div class="balance balance-v2">
                <div class="balance-title">
                  {{ t.navigation.net_profit }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.net_profit"></i>
                </div>
                <div class="balance-value" v-tooltip="getNetProfitMoney(1)">
                  <span class="d-xxl-none">{{ getNetProfitMoney() }}</span>
                  <span class="d-none d-xxl-inline-block" :class="(getNetProfitMoney() > 0) ? 'text-success' : 'text-danger'">{{ getNetProfitMoney() }}</span>
                  <span v-if="getPercentageChangeNetProfit('played_sport_bet_total_amount') != 0" class="trending" :class="(getPercentageChangeAmount('played_sport_bet_total_amount') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>%{{ getPercentageChangeAmount('played_sport_bet_total_amount') }}</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('played_sport_bet_total_amount') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
                </div>
              </div>
            </div>

            <div class="element-balances justify-content-between mobile-full-width pb-2 pt-2 b-b">
              <div class="balance balance-v2">
                <div class="balance-title">
                  {{ t.navigation.total_profit }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.total_profit"></i>
                </div>
                <div class="balance-value" v-tooltip="getAmountMoney('loss', 1)">
                  <span class="d-xxl-none">{{ getAmountMoney ('loss') }}</span>
                  <span class="d-none d-xxl-inline-block":class="(getAmountMoney ('loss') > 0) ? 'text-success' : 'text-danger'">{{ getAmountMoney ('loss') }}</span>

                  <span v-if="getPercentageChangeAmount('loss') != 0" class="trending" :class="(getPercentageChangeAmount('loss') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>{{ getPercentageChangeAmount('loss') }}%</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('loss') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
                </div>
              </div>
              <div class="balance balance-v2">
                <div class="balance-title">
                  {{ t.navigation.amount_of_prizes_paid }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.amount_of_prizes_paid"></i>
                </div>
                <div class="balance-value" v-tooltip="getEarningsMoney('win', 1)">
                  <span class="d-xxl-none">{{ getEarningsMoney ('win') }}</span>
                  <span class="d-none d-xxl-inline-block">{{ getEarningsMoney ('win') }}</span>

                  <span v-if="getPercentageChangeAmount('win') != 0" class="trending" :class="(getPercentageChangeAmount('win') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>{{ getPercentageChangeAmount('win') }}%</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('win') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
                </div>
              </div>
            </div>
            <div class="element-balances justify-content-between mobile-full-width pb-2 pt-2 b-b">
              <div class="balance balance-v2">
                <div class="balance-title">
                  {{ t.navigation.amount_of_waiting_waget }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.amount_of_waiting_waget"></i>
                </div>
                <div class="balance-value" v-tooltip="getAmountMoney('waiting', 1)">
                  <span class="d-xxl-none">{{ getAmountMoney ('waiting') }}</span>
                  <span class="d-none d-xxl-inline-block">{{ getAmountMoney ('waiting') }}</span>

                  <span v-if="getPercentageChangeAmount('waiting') != 0" class="trending" :class="(getPercentageChangeAmount('waiting') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>{{ getPercentageChangeAmount('waiting') }}%</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('waiting') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
                </div>
              </div>
              <div class="balance balance-v2">
                <div class="balance-title">
                  {{ t.navigation.amount_of_waiting_prize }} <i class="dashicons dashicons-info" v-tooltip="t.navigation.info.amount_of_waiting_prize"></i>
                </div>
                <div class="balance-value" v-tooltip="getEarningsMoney('waiting', 1)">
                  <span class="d-xxl-none">{{ getEarningsMoney ('waiting') }}</span>
                  <span class="d-none d-xxl-inline-block">{{ getEarningsMoney ('waiting') }}</span>

                  <span v-if="getPercentageChangeAmount('waiting') != 0" class="trending" :class="(getPercentageChangeAmount('waiting') > 0) ? 'trending-up-basic' : 'trending-down-basic'">
										<span>{{ getPercentageChangeAmount('waiting') }}%</span>
											<i class="os-icon" :class="(getPercentageChangeAmount('waiting') > 0) ? 'os-icon-arrow-2-up' : 'os-icon-arrow-2-down'"></i>
										</span>
                </div>
              </div>
            </div>

          </div>

          <div class="col-sm-12 col-xxl-6">
            <div class="row">
              <div class="col-sm-6 b-r b-b">
                <div class="el-tablo centered p-4">
                  <div class="value">
                    {{ getCountNformatter ('general') }}
                  </div>
                  <div class="label">
                    {{ t.navigation.bets }}
                  </div>
                </div>
              </div>
              <div class="col-sm-6 b-b">
                <div class="el-tablo centered p-4">
                  <div class="value">
                    {{ getCountNformatter ('waiting') }}
                  </div>
                  <div class="label">
                    {{ t.betting.title.waiting_bets }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 b-r b-b">
                <div class="el-tablo centered p-4">
                  <div class="value">
                    {{ getCountNformatter ('win') }}
                  </div>
                  <div class="label">
                    {{ t.betting.title.winning_bets }}
                  </div>
                </div>
              </div>
              <div class="col-sm-6 b-b">
                <div class="el-tablo centered p-4">
                  <div class="value">
                    {{ getCountNformatter ('loss') }}
                  </div>
                  <div class="label">
                    {{ t.betting.title.losed_bets }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 b-r">
                <div class="el-tablo centered p-3">
                  <div class="value">
                    {{ getCountNformatter ('refund') }}
                  </div>
                  <div class="label">
                    {{ t.betting.title.refunded_bets }}
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="el-tablo centered p-3">
                  <div class="value">
                    {{ getCountNformatter ('cancelled') }}
                  </div>
                  <div class="label">
                    {{ t.betting.title.cancelled_bets }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import formatter from '@/mixins/formatter'
  import analytic from '@/mixins/analytic';
  export default {
    name: 'overview',
    mixins: [analytic, formatter],
    props: ['cur', 'user'],
    data () {
      return {
        t: this.$root.t,
        tinfo: this.$root.tinfo,
        stats: null,
        netProfit: null,
        stats_10m: null,
        visitor: null,
        selectedAccountingPeriod: 'today',
        accountingPeriods: [
          { label: 'Today', value: 'today' },
          { label: 'Yesterday', value: 'yesterday' },
          { label: 'This Week', value: 'this_week' },
          { label: 'This Month', value: 'this_month' },
          { label: 'Q1', value: 'q1' },
          { label: 'Q2', value: 'q2' },
          { label: 'Q3', value: 'q3' },
          { label: 'Q4', value: 'q4' },
          { label: 'Financial First Half', value: 'first_financial_half' },
          { label: 'Financial Second Half', value: 'second_financial_half' },
        ]
      }
    },
    watch: {
      'selectedAccountingPeriod' () {
        this.betsOverview(this.selectedAccountingPeriod, this.cur, this.user).then(response => {
          this.fetchStats(response.body)
        })
      },
    },
    mounted () {
        this.fetchStats('this_month', this.cur, this.user).then(response => {
          this.fetchStats(response.body)
        })
    },
    methods: {
      fetchStats (data) {
        this.stats = data.result.stats;
        this.netProfit = data.result.net_profit;
        this.currency = data.result.currency;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/widget/overview.vue